import { render, staticRenderFns } from "./CoSharableInput.vue?vue&type=template&id=5142ef99&scoped=true&"
import script from "./CoSharableInput.vue?vue&type=script&lang=ts&"
export * from "./CoSharableInput.vue?vue&type=script&lang=ts&"
import style0 from "./CoSharableInput.vue?vue&type=style&index=0&id=5142ef99&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5142ef99",
  null
  
)

export default component.exports